import { render, staticRenderFns } from "./VisualizationUserAccessGDS.vue?vue&type=template&id=1534f360&lang=pug"
import script from "./VisualizationUserAccessGDS.vue?vue&type=script&lang=js"
export * from "./VisualizationUserAccessGDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1534f360')) {
      api.createRecord('1534f360', component.options)
    } else {
      api.reload('1534f360', component.options)
    }
    module.hot.accept("./VisualizationUserAccessGDS.vue?vue&type=template&id=1534f360&lang=pug", function () {
      api.rerender('1534f360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/VisualizationUserAccessGDS.vue"
export default component.exports